import React from "react";
import styled from 'styled-components';
import flipcardspic from '../pictures/flipcards.jpg';

class Flipcards extends React.Component {
render(){
const WORKCOVER = styled.div`
    width: 100%;
    height: 100%;
`;

const TITLE = styled.h1`
    margin: 0;
    padding-top: calc(30px + 8vw);
    padding-bottom: 3vh;
    text-align: center;
    color: black;
`;

const BOX = styled.div`
`;

const IMG = styled.img`
    width: 35%;
    height: 100%;
    display: block;
    margin: 0 auto;
    `;

const CONTENT = styled.div`
    padding: 3em;
`;

const TECH = styled.div`
    color: black;
    font-size:calc(10px + 0.4vw)
`;

const BUTTONS = styled.div`
    display: flex;
    justify-content: space-around;
    text-align:center;
    vertical-align: middle;
`;
const BUTTON = styled.a`
    width: calc(40px + 4vw);
    height: calc(20px + 2.5vw);
    line-height: calc(20px + 2.5vw);
    margin: 1em;
    padding: 0.23em 0.5em;
    font-size:calc(10px + 0.4vw)
    font-weight: bold;
    color: white;
    border-style: none;
    border-radius: 3px;
    text-decoration: none;
    background-color: #0F4137;
    `;

return(
<div>
<WORKCOVER>
    <TITLE>トルコ語神経衰弱</TITLE>
    <BOX>
        <IMG src= {flipcardspic} alt=""/>
        <CONTENT>
            <TECH>
            使用技術：<br/>
            HTML/CSS/jQuery/JavaScript<br/><br/>
            神経衰弱のトルコ語バージョンです。
            趣味でトルコ語を勉強しているので作ってみました。<br/>
            食べ物のイラストとそれを意味する単語がペアになっています。<br/>
            カードがペアになった時にはちょっとしたアニメーションを付けました。カードを揃えて画面下のネコを喜ばせてあげましょう！<br/>
            下記のイラスト・トルコ語対照表を見ながらぜひ遊んでみてください。<br/><br/>
            カードのイラスト・単語対照表<br/>
            köfte&nbsp;&nbsp;&nbsp;肉団子&nbsp;&nbsp;&nbsp;pasta&nbsp;&nbsp;&nbsp;ケーキ<br/>
            ekmek&nbsp;&nbsp;&nbsp;パン&nbsp;&nbsp;&nbsp;&nbsp;çay&nbsp;&nbsp;&nbsp;お茶<br/>
            balık&nbsp;&nbsp;&nbsp;魚&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;çorba&nbsp;&nbsp;&nbsp;スープ<br/>
            süt&nbsp;&nbsp;&nbsp;牛乳&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;domates&nbsp;&nbsp;&nbsp;トマト<br/>
            tavuk&nbsp;&nbsp;&nbsp;鶏肉&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;portakal suyu&nbsp;&nbsp;&nbsp;オレンジジュース<br/>
            </TECH>
            <BUTTONS>
                <BUTTON href="https://yukiamakawa.github.io/FlipCards-turkish/FlipCards-turkish.html" target="_blank">
                    デモ
                </BUTTON>
                <BUTTON href = "https://github.com/YukiAmakawa/FlipCards-turkish" target="_blank">
                    GitHub
                </BUTTON>
            </BUTTONS>
        </CONTENT>
    </BOX>
</WORKCOVER>

</div>
)}}

export default Flipcards;


// WEBPACK FOOTER //
// ./src/components/Flipcards.js